import React, { useState, useEffect } from 'react';
import api from '../utils/api';

function EmployeeDashboard() {
    const [tasks, setTasks] = useState([]);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const [tasksRes, statsRes] = await Promise.all([
                api.getTasks(),
                api.getTaskStats()
            ]);
            setTasks(tasksRes.data.tasks || []);
            setStats(statsRes.data.stats);
        } catch (error) {
            console.error('Error loading dashboard:', error);
        } finally {
            setLoading(false);
        }
    };

    const updateTaskStatus = async (id, status) => {
        try {
            await api.updateTask(id, { status });
            loadData();
        } catch (error) {
            alert('Error updating task');
        }
    };

    const getPriorityColor = (priority) => {
        const colors = {
            'Urgent': '#e74c3c',
            'High': '#e67e22',
            'Medium': '#f39c12',
            'Low': '#95a5a6'
        };
        return colors[priority] || '#95a5a6';
    };

    if (loading) return <div className="loading">Loading...</div>;

    return (
        <div className="dashboard">
            <h1>My Dashboard</h1>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon">📋</div>
                    <div className="stat-content">
                        <h3>Total Tasks</h3>
                        <p className="stat-value">{stats?.total || 0}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">⏳</div>
                    <div className="stat-content">
                        <h3>To Do</h3>
                        <p className="stat-value">{stats?.todo || 0}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">🔄</div>
                    <div className="stat-content">
                        <h3>In Progress</h3>
                        <p className="stat-value">{stats?.in_progress || 0}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">✅</div>
                    <div className="stat-content">
                        <h3>Completed</h3>
                        <p className="stat-value">{stats?.done || 0}</p>
                    </div>
                </div>
            </div>

            <h2>My Tasks</h2>
            <div className="tasks-grid">
                {tasks.map(task => (
                    <div key={task.id} className="task-card">
                        <div className="task-header">
                            <span className="task-id">#{task.id}</span>
                            <span 
                                className="priority-badge" 
                                style={{ backgroundColor: getPriorityColor(task.priority) }}
                            >
                                {task.priority}
                            </span>
                        </div>
                        <h3>{task.title}</h3>
                        {task.description && <p className="task-description">{task.description}</p>}
                        <div className="task-meta">
                            {task.client_name && <span>📁 {task.client_name}</span>}
                            {task.due_date && (
                                <span>📅 {new Date(task.due_date).toLocaleDateString()}</span>
                            )}
                        </div>
                        <div className="task-footer">
                            <select
                                value={task.status}
                                onChange={(e) => updateTaskStatus(task.id, e.target.value)}
                                className={`status-select ${task.status.toLowerCase().replace(' ', '-')}`}
                            >
                                <option value="Todo">To Do</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Done">Done</option>
                            </select>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EmployeeDashboard;
